module.exports = __webpack_public_path__ + "img/RegionMicroSynteny.7faabd87.jpg";